import type { SdkDnd } from '@Pages/pageRuntime/sdk/types';

let loadedDnd: SdkDnd | null = null;
let loadingDnd: Promise<void> | null = null;

export function preloadSdkDnd(): Promise<void> {
  loadingDnd ??= import('./index').then(({ sdkDnd }) => {
    loadedDnd = sdkDnd;
  });

  return loadingDnd;
}

export function prepareSdkDndForSource(
  sources: Array<string | null | undefined>
): Promise<void> | null {
  if (loadedDnd || !sources.some((source) => source && /\bDnd\b/.test(source))) {
    return null;
  }

  return preloadSdkDnd();
}

function requireSdkDnd(): SdkDnd {
  if (!loadedDnd) {
    throw preloadSdkDnd();
  }

  return loadedDnd;
}

export const lazySdkDnd = new Proxy({} as SdkDnd, {
  get: (_target, property) => Reflect.get(requireSdkDnd(), property),
  has: (_target, property) => Reflect.has(requireSdkDnd(), property),
  ownKeys: () => Reflect.ownKeys(requireSdkDnd()),
  getOwnPropertyDescriptor: (_target, property) =>
    Reflect.getOwnPropertyDescriptor(requireSdkDnd(), property)
});
